import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  { id: 'instagram', href: 'https://www.instagram.com/meowcentral', icon: 'ri-instagram-line' },
  { id: 'youtube', href: 'https://www.youtube.com/@meowcentral', icon: 'ri-youtube-line' },
  { id: 'facebook', href: 'https://www.facebook.com/meowcentral', icon: 'ri-facebook-line' },
  { id: 'twitter', href: 'https://twitter.com/meowcentral', icon: 'ri-twitter-x-line' },
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-500 to-teal-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/37bc7df8-b441-456a-b64e-dfe2e72930b6.png"
                alt="Logo"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
              <span className="font-heading font-bold text-xl sm:text-2xl">MeowCentral</span>
            </div>
            <p className="text-white/90 text-sm sm:text-base mb-4 sm:mb-6 font-body">
              The Internet's Favorite Cat Destination 🐾
            </p>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map(({ id, href, icon }) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
                  aria-label={id}
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4 uppercase">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Videos', path: '/videos' },
                { name: 'Memes', path: '/memes' },
                { name: 'Shop', path: '/shop' },
                { name: 'Adopt a Cat', path: '/adopt' },
                { name: 'Blog', path: '/blog' },
                { name: 'Wildcats', path: '/wildcats' },
                { name: 'Cat Care Guide', path: '/cat-care-guide' },
                { name: 'Cat Breeds', path: '/breeds' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-white transition-colors text-sm font-body inline-block cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-white/20 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-white/70 text-xs sm:text-sm font-body">
            © 2025 MeowCentral. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <Link to="/legal/terms" className="text-white/70 hover:text-white text-xs sm:text-sm font-body cursor-pointer">
              Terms
            </Link>
            <Link to="/legal/privacy" className="text-white/70 hover:text-white text-xs sm:text-sm font-body cursor-pointer">
              Privacy
            </Link>
            <Link to="/legal/cookies" className="text-white/70 hover:text-white text-xs sm:text-sm font-body cursor-pointer">
              Cookies
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white text-xs sm:text-sm font-body cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}